import { CountdownTimerOption, TimeCountDownFormat } from '@/constants/enum';

export const timerFormat = [
  {
    label: `02 days 10 hours 30 minutes 59 seconds`,
    value: TimeCountDownFormat.Full.toString(),
  },
  {
    label: `02 days 10 hours 30 minutes`,
    value: TimeCountDownFormat.DayHourMinute.toString(),
  },
  {
    label: `02 days 10 hours`,
    value: TimeCountDownFormat.DayHour.toString(),
  },
  {
    label: `10 hours 30 minutes 59 seconds`,
    value: TimeCountDownFormat.HourMinuteSecond.toString(),
  },
  {
    label: `10 hours 30 minutes`,
    value: TimeCountDownFormat.HourMinute.toString(),
  },
];

export const countdownMode = [
  {
    label: 'Next available cut-off time (includes non-working days and holidays)',
    value: CountdownTimerOption.NextCutoff.toString(),
  },
  {
    label: '23h59 of that day',
    value: CountdownTimerOption.EndOfDay.toString(),
  },
];
